import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { routes } from '../../constants';
import { selectIsAuthenticated } from '../../reducers/user.selectors';
import useRouter from '../../utils/useRouter';

const RedirectIfLoggedOut: React.FC<{ children?: React.ReactNode; redirectUrl?: string }> = (
	props
) => {
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const { router, match } = useRouter();
	const redirectUrl = props.redirectUrl ?? `${match.location.pathname}${match.location.search}`;
	const loginRedirectUrl = `/${routes.login.root}?redirect=${encodeURIComponent(redirectUrl)}`;

	useEffect(() => {
		if (!isAuthenticated) {
			router.replace(loginRedirectUrl);
		}
	}, [isAuthenticated, loginRedirectUrl, router]);

	if (!isAuthenticated) {
		return <></>;
	}

	return <>{props.children}</>;
};

export default RedirectIfLoggedOut;
